const Cancel = () => {
  return <div className="-mx-2 -my-12 flex flex-shrink flex-grow flex-col sm:-mx-6 lg:-mx-8">Payment failed.</div>;
};

export default Cancel;
